import GoogleIcon from "../../../../Assets/images/GoogleIcon.jpg";
import TechStartupOfYear from "../../../../Assets/images/TechStartupOfYear.jpg";
import MetaIcon from "../../../../Assets/images/MetaIcon.jpg";
import LinkedInIcon from "../../../../Assets/images/LinkedInIcon.jpg";
import "./style.scss";

const achievementList = [
  { title: "Tech startup of the year", icon: TechStartupOfYear },
  { title: "Backed by Google", icon: GoogleIcon },
  { title: "Official Partner", icon: MetaIcon },
  { title: "Top 20 startups of the year", icon: LinkedInIcon },
];

const AchievementSection = () => {
  return (
    <div className="achievements">
      <div className="achievements__list">
        {achievementList.map((achievement) => {
          return (
            <div className="achievements__list--item">
              <img src={achievement.icon} className="achievements__list--item-logo" />
              <div className="achievements__list--item-title">{achievement.title}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AchievementSection;
